<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title hide-for-small-only">
        <h1 class="main-title">{{ this.$t("invoice.specifications") }}</h1>
      </div>
      <div class="panel">
        <div class="row">
          <div class="small-12 columns">
            <invoice-specification-filter-form @submit="loadData"/>
            <br clear="all">
            <nav class="toolbar">
              <ul/>
            </nav>
            <div
              v-if="invoiceSpecifications && invoiceSpecifications.length !== 0"
              class="datatable-wrapper"
            >
              <div class="dataTables_wrapper dt-foundation no-footer">
                <table class="datatable dataTable no-footer" role="grid">
                  <thead>
                    <table-header :order-by="orderBy"
                                  :order-direction="orderDirection"
                                  :columns="headerColumns"
                                  translation-prefix="invoice.invoiceHeaderColumns."
                                  @orderingChanged="setOrderingAndLoadData"/>
                  </thead>
                  <tbody>
                    <tr is="invoice-specifications-list-item"
                        v-for="invoice in invoiceSpecifications"
                        :invoice="invoice"
                        :key="invoice.invoiceNumber"/>
                  </tbody>
                </table>
                <div class="bottom">
                  <div class="dataTables_paginate paging_full_numbers">
                    <invoice-specifications-list-paginator
                      :page-size="pageSize"
                      @paginationChanged="loadData"
                    />
                  </div>
                  <div class="dataTables_length">
                    <label>
                      <select-input
                        id="page_size"
                        :value="'' + pageSize"
                        :options="pageSizeOptions"
                        :$v="$v.pageSize"
                        name="page-size"
                        @change="setPageSize"
                      />
                      {{ this.$t('pagination.items-per-page') }}
                    </label>
                  </div>
                </div>
                <div class="clear"/>
              </div>
            </div>
            <invoice-specifications-result-message
              v-if="visibleMessage"
            />
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import VLayout from '../layouts/Default'
import InvoiceSpecificationsListItem from '../components/invoiceSpecifications/InvoiceSpecificationsListItem'
import InvoiceSpecificationsListPaginator from '../components/invoiceSpecifications/InvoiceSpecificationsListPaginator'
import InvoiceSpecificationsResultMessage from '../components/invoiceSpecifications/InvoiceSpecificationsResultMessage'
import SelectInput from '../components/forms/fields/SelectInput'
import {
  SET_INVOICE_SPECIFICATIONS_PAGE_SIZE,
  SET_INVOICE_SPECIFICATIONS_ORDER_BY,
  SET_INVOICE_SPECIFICATIONS_ORDER_DIRECTION
} from '../store/modules/invoice-specifications/mutation-types'
import InvoiceSpecificationFilterForm from '../components/forms/InvoiceSpecificationFilterForm'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'
import {buildTableHeaderColumn} from '../types/table-header-column'
import TableHeader from '../components/tableHeader/TableHeader'

export default {
  name: 'InvoiceSpecificationPage',
  components: {
    InvoiceSpecificationFilterForm,
    VLayout,
    InvoiceSpecificationsListPaginator,
    InvoiceSpecificationsListItem,
    InvoiceSpecificationsResultMessage,
    SelectInput,
    TableHeader
  },
  mixins: [showAlertErrorHandler],
  data () {
    return {
      pageSizeOptions: [
        {value: '10', text: '10'},
        {value: '25', text: '25'},
        {value: '50', text: '50'},
        {value: '100', text: '100'}
      ],
      visibleMessage: false,
      headerColumns: [
        buildTableHeaderColumn('invoiceNumber', '147px'),
        buildTableHeaderColumn('invoiceDate', '103px'),
        buildTableHeaderColumn('invoiceType', '284px'),
        buildTableHeaderColumn('amount', '134px'),
        buildTableHeaderColumn('export', '90px', null, false)
      ]
    }
  },
  computed: {
    ...mapState({
      invoiceSpecifications: state => state.invoiceSpecifications.invoiceSpecificationsForCurrentFilter,
      pageSize: state => state.invoiceSpecifications.invoiceSpecificationsPageSize,
      currentPage: state => state.invoiceSpecifications.invoiceSpecificationsCurrentPageNumber,
      orderBy: state => state.invoiceSpecifications.invoiceSpecificationsOrderBy,
      orderDirection: state => state.invoiceSpecifications.invoiceSpecificationsOrderDirection
    })
  },
  created () {
    this.loadData()
  },
  validations () {
    return {
      pageSize: {}
    }
  },
  methods: {
    loadData: async function () {
      try {
        this.visibleMessage = false
        await this.$store.dispatch('invoiceSpecifications/loadInvoiceSpecifications')
        this.setMessageVisibility()
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
      }
    },
    setPageSize: function (value) {
      value = parseInt(value)
      this.$store.commit(`invoiceSpecifications/${SET_INVOICE_SPECIFICATIONS_PAGE_SIZE}`, value)
      this.loadData()
    },
    setMessageVisibility: function () {
      this.invoiceSpecifications.length === 0 ? this.visibleMessage = true : this.visibleMessage = false
    },
    setOrderingAndLoadData (ordering) {
      this.$store.commit(`invoiceSpecifications/${SET_INVOICE_SPECIFICATIONS_ORDER_BY}`, ordering.orderBy)
      this.$store.commit(`invoiceSpecifications/${SET_INVOICE_SPECIFICATIONS_ORDER_DIRECTION}`, ordering.orderDirection)
      this.loadData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/InvoiceSpecificationsPage.vue